import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ErrorMessage } from 'formik';

export const FormFieldWrapper = ({
  name,
  label,
  children,
  type,
  required = false,
  list = false,
  className = '',
  error = null,
  style = {}
}) => {
  const base = list ? 'swformfieldlist' : 'swformfield';
  return (
    <div
      className={classNames({
        [base]: true,
        [`${base}--${type}`]: true,
        [`${base}--required`]: required,
        [className]: true
      })}
      style={style}
    >
      <label className={`${base}__label`}>{label}</label>
      {list ? (
        children
      ) : (
        <div className="swformfieldwrapper">
          {children}
          <div className="swformfield__background"></div>
        </div>
      )}
      <ErrorMessage name={name} component="div" className="error-message" />
      {error && (
        <div className="error" role="alert">
          {error}
        </div>
      )}
    </div>
  );
};

FormFieldWrapper.propTypes = {
  children: PropTypes.any,
  label: PropTypes.any,
  type: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  list: PropTypes.bool,
  className: PropTypes.string,
  error: PropTypes.string,
  style: PropTypes.any
};
